module.exports = __webpack_public_path__ + "static/media/brego3592.e29c72be.jpg";